import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ThemeColors {
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  text: string;
}

interface ThemeState {
  mode: 'light' | 'dark';
  colors: ThemeColors;
  fontSize: 'small' | 'medium' | 'large';
  tenantBranding: {
    logo: string | null;
    colors: Partial<ThemeColors>;
  };
}

const initialState: ThemeState = {
  mode: 'dark',
  colors: {
    primary: '#0F172A',
    secondary: '#1E293B',
    accent: '#38BDF8',
    background: '#0F172A',
    text: '#F8FAFC',
  },
  fontSize: 'medium',
  tenantBranding: {
    logo: null,
    colors: {},
  },
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleThemeMode: (_state) => {
      _state.mode = _state.mode === 'light' ? 'dark' : 'light';
      // Update colors based on mode
      if (_state.mode === 'light') {
        _state.colors = {
          primary: '#F8FAFC',
          secondary: '#E2E8F0',
          accent: '#0EA5E9',
          background: '#FFFFFF',
          text: '#0F172A',
        };
      } else {
        _state.colors = initialState.colors;
      }
    },
    setFontSize: (state, action: PayloadAction<ThemeState['fontSize']>) => {
      state.fontSize = action.payload;
    },
    setTenantBranding: (state, action: PayloadAction<ThemeState['tenantBranding']>) => {
      state.tenantBranding = action.payload;
    },
    resetTheme: (_state) => {
      return initialState;
    },
  },
});

export const { toggleThemeMode, setFontSize, setTenantBranding, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
